/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Start_LabelInputs */



/**
* | output |
* | --- |
* | "Start project sync" |
*
* @param {Team_Sync_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_start_label = /** @type {((inputs?: Team_Sync_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer la synchronisation du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektsynchronisierung starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia la sincronizzazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начать синхронизацию проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar sincronización del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始项目同步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの同期を開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सिंक शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar sincronização do projeto")
	return /** @type {LocalizedString} */ ("Start project sync")
});